import { Link } from 'react-router-dom';
import { Users, Skull, Eye, Star, Flame, Zap, Shield, Film } from 'lucide-react';
import { motion } from 'framer-motion';

const iconMap = {
  skull: Skull,
  eye: Eye,
  star: Star,
  flame: Flame,
  zap: Zap,
  shield: Shield,
  film: Film
};

export const GameCard = ({ game, index = 0 }) => {
  const IconComponent = iconMap[game.icon] || Skull;

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      data-testid={`game-card-${game.id}`}
      className="h-full"
    >
      <Link 
        to={`/games/${game.id}`}
        className="glass-dark rounded-xl p-4 sm:p-6 card-hover group cursor-pointer border border-gray-700 flex flex-col h-full"
      >
        {/* Image - Full poster visible (mobile + desktop) */}
        <div className="mb-3 sm:mb-4 flex-shrink-0">
          <div className="aspect-[3/4] w-full rounded-lg overflow-hidden bg-black/60 flex items-center justify-center">
            <img
              src={game.imageUrl || '/oyunlar/mexluq (1).jpeg'}
              alt={game.name}
              className="w-full h-full object-contain"
              loading="lazy"
            />
          </div>
        </div>

        {/* Title with Icon */}
        <div className="flex items-center mb-3 sm:mb-4 flex-shrink-0">
          <IconComponent className="w-5 h-5 sm:w-6 sm:h-6 text-red-500 mr-2 sm:mr-3 group-hover:scale-110 transition-transform" />
          <h3 className="text-base sm:text-xl font-bold text-white line-clamp-1">{game.name}</h3>
        </div>

        {/* Info - Flex Grow */}
        <div className="space-y-2 sm:space-y-3 flex-grow text-sm sm:text-base">
          <div className="flex justify-between items-center">
            <span className="text-gray-400 font-medium">İştirakçı sayı:</span>
            <span className="text-white font-bold">{game.playerCount || '2-20'} nəfər</span>
          </div>
          {game.hasLevelChoice !== false && (
            <div className="flex justify-between items-center">
              <span className="text-gray-400 font-medium">Səviyyə seçimi:</span>
              <span className="text-green-400 font-bold">Var</span>
            </div>
          )}
          {game.duration && (
            <div className="flex justify-between items-center">
              <span className="text-gray-400 font-medium">Müddət:</span>
              <span className="text-white font-bold">{game.duration} dəq</span>
            </div>
          )}
          {game.price && (
            <div className="flex justify-between items-center">
              <span className="text-gray-400 font-medium">Qiymət:</span>
              <span className="text-red-400 font-bold">{game.price} AZN</span>
            </div>
          )}
        </div>

        {/* CTA Button - Fixed at Bottom */}
        <div className="w-full mt-3 sm:mt-4 btn-primary text-white px-3 py-2 sm:px-4 rounded-lg font-bold text-center text-sm sm:text-base flex-shrink-0">
          Ətraflı Məlumat
        </div>
      </Link>
    </motion.div>
  );
};
